'use strict';

import template from '../../templates/payrolls/Payroll.ejs';
import payrollEditModal from '../../templates/payrolls/PayrollEditModal.ejs';
import ModalForm from '../../../commons/views/ModalForm';
import Download from 'downloadjs';
import Alerts from 'lib/alerts';
import moment from 'moment';
import {payrollStatus} from '../../../new-models/payroll';

module.exports = Backbone.View.extend({
    tagName: 'tr',
    events: {
        'click .js-cancel': 'cancel',
        'click .js-revert': 'revert',
        'click .js-create-archive': 'createArchive',
        'click .js-download': 'download',
        'click .js-makeArchiveDownloadable:not(disabled)':
            'makeArchiveDownloadable',
        'click .js-markAsManuallyInvoiced:not(disabled)':
            'markAsManuallyInvoiced',
        'click .js-unlock': 'unlock',
        'click .js-edit': 'togglEditModal'
    },

    editModal: null,

    initialize: function(options) {
        this.options = {
            archive: options.archive,
            calculations: options.calculations
        };
        this.editModal = new ModalForm({
            template: payrollEditModal,
            model: this.model
        });
        this.editModal.on('saved', this.render, this);
    },

    render: function() {
        this.$el.html(template({
            model: this.model,
            archive: this.options.archive,
            calculations: this.options.calculations,
            moment: moment
        }));
        return this;
    },

    download: function(ev) {
        const $button = this.$(ev.currentTarget);
        const attachment = this.options[$button.data('file')];

        if (attachment) {
            /* jQuery ajax cannot be used here because messes up the response */
            const xhr = new XMLHttpRequest();
            xhr.open('GET', attachment.downloadUrl(), true);
            xhr.responseType = 'blob';
            xhr.onload = function() {
                // TODO: handle errors
                if (this.status == 200) {
                    // get binary data as a response
                    var blob = this.response;
                    Download(blob, attachment.get('name'), 'application/zip');
                }
            };
            xhr.send();
        } else {
            Alerts.show('warning', {
                text: `The file is being processed and should be ready ` +
                    `shortly. It usually takes a few seconds or a minute at ` +
                    `busy periods. Close this popup and refresh the page ` +
                    `to see if it is ready`,
                customClass: 'sweet-alert-error'
            });
        }
    },

    makeArchiveDownloadable: function() {
        Alerts.show('dangerConfirm', {
            title: 'Warning!',
            text: 'Before performing this action make sure you waited a ' +
                'reasonable amount of time. After performing this action ' +
                'review the file to make sure all contents are present.',
            confirmButtonText: 'Continue',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.makeArchiveDownloadable()
                    .then(() => window.location.reload())
                    .fail(err => Alerts.show('criticalError', err));
            }
        });
    },

    markAsManuallyInvoiced: function() {
        Alerts.show('dangerConfirm', {
            title: 'This operation is not reversible!',
            text: 'If you go ahead with this, your username will be logged. ' +
                'This operation is not reversible so you have to make sure ' +
                'a manual invoice for this payroll is created in chargebee',
            confirmButtonText: 'Continue',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.markAsManuallyInvoiced()
                    .then(() => window.location.reload())
                    .fail(err => Alerts.show('criticalError', err));
            }
        });
    },

    cancel: function() {
        var warnTextByStatus = {
            5: 'You have already recevied payment for this payroll. ',
            6: 'Government forms have already been signed. ',
            7: 'Forms have already been submitted to the government. ',
            8: 'Forms have been processed. '
        };

        Alerts.show('dangerConfirm', {
            title: 'Are you sure you want to cancel this payroll?',
            text:  (warnTextByStatus[this.model.get('status')] || '') +
                'You will lose any generated or uploaded forms and receipts',
            confirmButtonText: 'Yes, Cancel',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.destroy().then(
                    () => this.remove(),
                    err => Alerts.show('criticalError', err)
                );
            }
        });
    },

    revert: function() {
        Alerts.show('dangerConfirm', {
            title: 'Are you sure you want to revert this payroll?',
            text:  'You will lose all generated and uploaded files, ' +
                'including any emailed payslips and signed forms.',
            confirmButtonText: 'Yes, Revert',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.revert()
                    .then(() => this.model.fetch())
                    .then(() => this.render())
                    .catch(err => { Alerts.show('criticalError', err); });
            }
        });
    },

    createArchive: function() {
        Alerts.show('dangerConfirm', {
            title: 'Are you sure you want to recreate ' +
                'archive file for this payroll?',
            confirmButtonText: 'Yes',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.createArchive().then(
                    () => {},
                    err => Alerts.show('criticalError', err)
                );
            }
        });
    },

    unlock: function() {
        Alerts.show('dangerConfirm', {
            title: 'Warning!',
            text: 'Before performing this action make sure you waited a ' +
                'reasonable amount of time. After performing this action ' +
                'review the payroll to make sure it\'s displaying all content' +
                'correctly',
            confirmButtonText: 'Continue',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.save({running: false})
                    .then(() => this.model.setStatus(payrollStatus.INITIAL))
                    .then(() => this.model.fetch())
                    .then(() => this.render())
                    .fail(err => Alerts.show('criticalError', err));
            }
        });
    },

    togglEditModal: function() {
        this.editModal.show();
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/payrolls/Payroll.js